import type {Component} from '@kpsys/angularjs-register';
import type {Department, NamedIdentified, RichDocument} from 'typings/portaro.be.types';
import type ExemplarList from '../exemplar-list';
import type ExemplarService from '../exemplar.service';

export class KpExemplarsComponentController implements KpExemplarsComponentBindings {
    public document: RichDocument;
    public exemplarList: ExemplarList;
    public properties: NamedIdentified<string>[];
    public settings: any;

    /*@ngInject*/
    constructor(private exemplarService: ExemplarService) {
    }

    public async createExemplar(department: Department) {
        await this.exemplarService.createExemplarByFormAndReload(this.document, department);
    }
}

/**
 * @ngdoc component
 * @name kpExemplars
 * @module uc.record
 *
 * @param {RichDocument} document
 * @param {ExemplarList} exemplarList
 * @param {NamedIdentified[]} properties
 * @param {any} settings
 *
 * @description
 *
 */
export default class KpExemplarsComponent implements Component<KpExemplarsComponentBindings> {
    public static readonly componentName = 'kpExemplars';

    public templateUrl = require('./kp-exemplars.tpl.ftl');

    public bindings = {
        document: '<',
        exemplarList: '<',
        properties: '<',
        settings: '<'
    } as const;

    public controller = KpExemplarsComponentController;
}

interface KpExemplarsComponentBindings {
    document: RichDocument;
    exemplarList: ExemplarList;
    properties: NamedIdentified<string>[];
    settings: any;
}